(function () {
  function stripText(node) {
    return (node.textContent || '').replace(/\s+/g, ' ').trim();
  }

  // Construit un aperçu qui garde le 1er Hx tel quel + tronque le 1er P après
  function buildSmartPreview(html, maxChars) {
    const wrap = document.createElement('div');
    wrap.innerHTML = html;

    // Cherche un titre h1..h6 puis le premier paragraphe après
    const heading = wrap.querySelector('h1, h2, h3, h4, h5, h6');
    let previewHeadingHTML = '';
    let previewParaHTML = '';

    if (heading) {
      previewHeadingHTML = heading.outerHTML;

      // 1er paragraphe APRES le heading (pas dedans)
      let p = heading.nextElementSibling;
      while (p && p.tagName.toLowerCase() !== 'p') {
        p = p.nextElementSibling;
      }
      if (!p) {
        // fallback : 1er paragraphe global
        p = wrap.querySelector('p');
      }
      if (p) {
        const txt = stripText(p);
        previewParaHTML = '<p>' + (txt.length > maxChars ? (txt.slice(0, maxChars).trim() + '…') : txt) + '</p>';
      }
    } else {
      // Pas de heading : on prend le 1er paragraphe
      const p = wrap.querySelector('p') || wrap.firstElementChild;
      if (p) {
        const txt = stripText(p);
        // Si le 1er élément n’est pas un <p>, on garde sa balise si c’est un <ul>/<ol>, sinon on force <p>
        if (p.tagName && p.tagName.toLowerCase() === 'p') {
          previewParaHTML = '<p>' + (txt.length > maxChars ? (txt.slice(0, maxChars).trim() + '…') : txt) + '</p>';
        } else {
          previewParaHTML = '<p>' + (txt.length > maxChars ? (txt.slice(0, maxChars).trim() + '…') : txt) + '</p>';
        }
      }
    }

    return previewHeadingHTML + previewParaHTML;
  }

  function setButtonState(btn, expanded) {
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    const more = btn.querySelector('.label-more');
    const less = btn.querySelector('.label-less');
    if (more) more.hidden = !!expanded;
    if (less) less.hidden = !expanded;
    btn.classList.toggle('button-show-less', !!expanded);
    btn.classList.toggle('button-show-more', !expanded);
  }

  function animateHeight(el, toHeight, cb) {
    const from = el.getBoundingClientRect().height;
    el.style.maxHeight = from + 'px';
    el.offsetHeight;
    el.style.maxHeight = toHeight + 'px';
    el.style.transition = 'max-height 220ms ease';
    function done() {
      el.style.transition = '';
      el.style.maxHeight = '';
      el.removeEventListener('transitionend', done);
      cb && cb();
    }
    el.addEventListener('transitionend', done);
  }

  function measureHeight(el) {
    const clone = el.cloneNode(true);
    clone.style.visibility = 'hidden';
    clone.style.position = 'absolute';
    clone.style.inset = '0 auto auto -9999px';
    document.body.appendChild(clone);
    const h = clone.getBoundingClientRect().height;
    document.body.removeChild(clone);
    return h;
  }

  function initOne(container) {
    const fullTpl = container.querySelector('.seo-excerpt__full');
    const contentEl = container.querySelector('.seo-excerpt__content');
    const boxEl = container.querySelector('.seo-excerpt__box');
    const fadeEl = container.querySelector('.seo-excerpt__fade');
    const btn = container.querySelector('[data-seo-toggle-btn]');
    const maxChars = parseInt(container.getAttribute('data-seo-chars') || '350', 10);

    if (!fullTpl || !contentEl || !btn) return;

    const fullHTML = fullTpl.innerHTML;
    const previewHTML = buildSmartPreview(fullHTML, maxChars);

    // Si le HTML complet tient dans l’aperçu (très court), on affiche tout et on masque le bouton
    const tmp = document.createElement('div');
    tmp.innerHTML = fullHTML;
    const fullTextLen = (tmp.textContent || '').replace(/\s+/g, ' ').trim().length;

    if (fullTextLen <= maxChars * 1.2) {
      contentEl.innerHTML = fullHTML;
      if (fadeEl) fadeEl.style.display = 'none';
      btn.style.display = 'none';
      return;
    }

    // ÉTAT COLLAPSÉ : heading gardé + 1er paragraphe tronqué
    contentEl.innerHTML = previewHTML;
    container.classList.add('is-collapsed');
    if (fadeEl) fadeEl.hidden = true; // on retire l’overlay pour éviter les “trous”
    setButtonState(btn, false);

    btn.addEventListener('click', function () {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      if (!expanded) {
        // Expand
        const hBefore = measureHeight(boxEl);
        contentEl.innerHTML = fullHTML;
        const hAfter = measureHeight(boxEl);
        animateHeight(boxEl, hAfter, function () {
          container.classList.remove('is-collapsed');
        });
        setButtonState(btn, true);
      } else {
        // Collapse
        const hBefore = measureHeight(boxEl);
        contentEl.innerHTML = previewHTML;
        const hAfter = measureHeight(boxEl);
        animateHeight(boxEl, hAfter, function () {
          container.classList.add('is-collapsed');
        });
        setButtonState(btn, false);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-seo-toggle]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();